export enum FiltersChipsNames {
  TYPE = 'Type',
  SITE = 'Site',
  TAG = 'Tag',
  TIP = 'Tips Content',
  DATE = 'Date',
  KEYWORD = 'Keyword',
  AUTHOR = 'Author',
}
